import { Navigate, useLocation } from 'react-router-dom';
import { buildTenantPath } from '@web-config-app/core';
import { useTenantId } from '../../hooks/use-tenant-id/use-tenant-id';

/**
 * Redirects legacy `/domains/...` URLs to the same path under the
 * tenant the user is currently logged in as (`/tenants/:tenantId/...`).
 * `ValidateRouteParams` then rewrites the domain-based path to the
 * new module structure. Falls back to `/` (tenant selection) when no
 * tenant is stored.
 */
export const LegacyUrlRedirect = () => {
  const location = useLocation();
  const { tenantId } = useTenantId();

  return (
    <Navigate
      to={buildTenantPath(tenantId, `${location.pathname}${location.search}`)}
      replace
    />
  );
};
